// components/Players/PlayersView.jsx
import React, { memo } from "react";
import PropTypes from "prop-types";

// components
import Player from "components/Shared/Player/Player";

// styles
import styles from "./PlayersView.module.scss";

// constants
import { GAME_STATES } from "constants/constants";

function PlayersView({ players = [], gameState }) {
    const leftPlayers = players.filter((_, i) => i % 2 === 0).slice(0, 4);
    const rightPlayers = players.filter((_, i) => i % 2 === 1).slice(0, 4);
    const show = gameState !== GAME_STATES.GAME_OVER && gameState !== GAME_STATES.GAME_START_VIDEO;

    return (
        <div className={styles.playersView} data-show={show ? "true" : "false"}>
            <div className={`${styles.playersColumn} ${styles.playersLeft}`}>
                {leftPlayers.map((p) => (
                    <div key={p.id} className={`${styles.playerItem} ${styles.fromLeft}`}>
                        <Player player={p} side="left" orientation="landscape" />
                    </div>
                ))}
            </div>
            <div className={`${styles.playersColumn} ${styles.playersRight}`}>
                {rightPlayers.map((p) => (
                    <div key={p.id} className={`${styles.playerItem} ${styles.fromRight}`}>
                        <Player player={p} side="right" orientation="landscape" />
                    </div>
                ))}
            </div>
        </div>
    );
}

PlayersView.propTypes = {
    players: PropTypes.array,
    show: PropTypes.bool,
};

export default memo(PlayersView);
